// extracted by mini-css-extract-plugin
module.exports = {"card":"HomeNavigationCard_card__1TLvH","content":"HomeNavigationCard_content__2Tuky","icon":"HomeNavigationCard_icon__19cqc","title":"HomeNavigationCard_title__yNV4h"};